<style lang="scss" scoped>
.qrcode-page {
  .qrcode-container {
    margin-top: 100px;
    width: 100%;
    .qrcode-canvas {
      width: 700px;
      height: 700px;
      margin: 0 auto;
    }
  }
  .pid-txt {
    text-align: center;
    margin-top: 40px;
    font-size: 44px;
  }

}
</style>

<template>
  <div class="qrcode-page">
    <div class="qrcode-container">
      <div class="qrcode-canvas" id="qrcode-canvas"></div>
    </div>
    <!-- <div class="pid-txt">商品编号：{{pid}}</div> -->
    <div class="pid-txt">价格：{{'¥' + price}}</div>
    <div class="pid-txt">名称：{{desc}}</div>
    <div class="pid-txt">商家：{{name}}</div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { HOST_ADDRESS } from '../../../common/constant'

export default {
  data() {
    return {
      pid: '',
      name: '',
      price: '',
      desc: ''
    }
  },
  created() {
    const { pid } = this.$route.params
    const { name = '', price = '', desc = '' } = this.$route.query
    this.pid = pid
    this.name = name
    this.price = price
    this.desc = desc
  },
  mounted() {
    const windowWidth = window.screen.width
    const rate = windowWidth / 750
    const qrCode = new QRCode('qrcode-canvas', {
      text: `${HOST_ADDRESS()}purchase-test/product-detail/${this.pid}`,
      width: 700 * rate,
      height: 700 * rate,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: 3,
    });
  }
}
</script>